import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";
import Button from "material-ui/Button";
import OneDirectionSync from "../../../Icons/OneDirectionSync";
import CancelCircle from "../../../Icons/CancelCircle";
import ArrowToolTip from "../../../common/ArrowToolTip";
import AddButton from "../common/AddButton";
import Chip from "material-ui/Chip";
import {
  SalesforceImportStep,
  SalesforceSettingStep,
  salesforceImportMappingFormProps,
  SalesforceObjectType,
} from "../../../../constants/ComponentTypes";
import { defaultSalesforceMapping } from "../../../../constants/SalesforceMapping";
const styles = () => ({
  table: {
    border: "1px solid #E7E9EB",
    width: "100%",
  },

  tableHeader: {
    background: "#F4F6F9",
    fontSize: "13px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  },

  tableRow: {
    borderTop: "1px solid #E7E9EB",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
  },

  headerCell: {
    padding: "16px 25px",
    boxSizing: "border-box",
  },

  tableCell: {
    boxSizing: "border-box",
    height: "100%",
    position: "relative",
  },

  paddingBox: {
    padding: "27px 25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "auto",
    boxSizing: "border-box",
  },

  warning: {
    padding: "0px 25px 27px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "auto",
    boxSizing: "border-box",
    fontSize: "11px",
    color: "red"
  },

  previewBox: {
    padding: "11px 25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
  },

  tableCellCol1: {
    fontWeight: "bold",
  },

  col1: {
    width: "30.5%",
  },

  col2: {
    width: "50%",
    borderLeft: "1px solid #E7E9EB",
    borderRight: "1px solid #E7E9EB",
  },

  col3: {
    width: "19.5%",
  },

  placeholder: {
    color: "#B1B3B9",
    fontSize: "15px",
  },

  syncBtn: {
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    background: "#FFFFFF",
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translate(50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    minWidth: "unset",
    minHeight: "unset",
    boxSizing: "border-box",
    padding: 0,
    zIndex: 1,
    "&:hover": {
      background: "#FFFFFF",
      cursor: "auto",
    },
  },

  flex: {
    flex: 1,
  },

  chipContainer: {
    display: "flex",
    overflow: "scroll",
    marginRight: "8px",
    alignItems: "center",
  },

  chipRoot: {
    margin: "3px 10px 3px 0",
    float: "left",
    backgroundColor: "#F2F6FF",
    border: "#9CC0FF solid 1px",
    color: "#5593FF",
    height: "37px",
    borderRadius: "2px",
  },

  chipLabel: {
    padding: "5px 17px 5px 10px",
    fontSize: "13px",
    fontWeight: "bold",
  },

  chipRootGrey: {
    margin: "3px 10px 3px 0",
    float: "left",
    backgroundColor: "#F4F6F9",
    border: "#E7E9EB solid 1px",
    color: "#181819",
    height: "37px",
    borderRadius: "2px",
  },

  chipLabelGrey: {
    padding: "8px",
    fontSize: "13px",
    fontWeight: "bold",
  },

  previewItem: {
    color: "#71737B",
    fontSize: "11px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
    marginBottom: "2px",
  },

  formControl: {
    width: "100%",
  },
});

class MappingTable extends React.Component {
  handleUpdateMapping = (key, value) => {
    let mapping = this.props.mapping.set(key, value);
    this.props.updateMapping(mapping);
  };

  handleChipsDelete = (key, field) => {
    let set = this.props.mapping.get(key);
    set = set.delete(field);
    this.props.updateMapping(this.props.mapping.set(key, set));
  };

  isFieldEmptySelection = (field) => {
    let isEmpty = true;
    let set = this.props.mapping.get(field);
    if (set) {
      isEmpty = set.count() === 0;
    }
    return isEmpty;
  };

  isRequiredField = (field) => {
    return (
      field === "post_code" ||
      field === "company" ||
      field === "name" ||
      field === "address"
    );
  };

  isOneField = (field) => {
    return (
      field === "tel" ||
      field === "fax" ||
      field === "email"
    );
  };

  render() {
    const { classes, step, preview, enableEdit, disabled } = this.props;

    return (
      <div
        className={classes.table}
        style={{ pointerEvents: disabled ? "none" : "auto" }}
      >
        <div className={classes.tableHeader}>
          <div
            className={classNames(classes.headerCell, classes.col1)}
            style={{ background: "#FAFAFA" }}
          >
            Keyman Letter項目
          </div>
          <div className={classNames(classes.headerCell, classes.col2)}>
            Salesforce項目
          </div>
          <div className={classNames(classes.headerCell, classes.col3)}>
            情報プレビュー
          </div>
        </div>
        {salesforceImportMappingFormProps.map((item, i) => {
          let displayAddButton = true;
          let displayDeleteButton = true;

          if (
            !enableEdit ||
            (this.isRequiredField(item.key) &&
              defaultSalesforceMapping.hasOwnProperty(this.props.sobject) &&
              defaultSalesforceMapping[this.props.sobject].hasOwnProperty(
                item.key
              ))
          ) {
            displayAddButton = false;
            displayDeleteButton = false;
          } else if (
            (this.isOneField(item.key) &&
            this.props.mapping.get(item.key).count() > 0)) {
              displayAddButton = false;
          }

          return (
            <div className={classes.tableRow} key={i}>
              <div
                className={classNames(
                  classes.tableCell,
                  classes.col1,
                  classes.tableCellCol1
                )}
              >
                <div>
                  <div className={classes.paddingBox}>
                    {item.value}
                  </div>
                  {this.props.sobject === SalesforceObjectType.CONTACT.value && item.key === "post_code" &&
                    <div className={classes.warning}>※取引先責任者の郵便番号(郵送先)がない場合、取引先の郵便番号(納入先)が適用されます。</div>
                  }
                  {this.props.sobject === SalesforceObjectType.CONTACT.value && item.key === "address" && (
                    <div className={classes.warning}>※取引先責任者の住所(郵送先)がない場合、取引先の住所(納入先)が適用されます。</div>
                  )}
                </div>
                <ArrowToolTip text="SalesforceからKeyman Letterからへの単方向同期">
                  <Button className={classes.syncBtn}>
                    <OneDirectionSync
                      color="#5a5b62"
                      width={20}
                      height={20}
                      style={{
                        transform: "scale(-1, -1)",
                      }}
                    />
                  </Button>
                </ArrowToolTip>
              </div>
              <div className={classNames(classes.tableCell, classes.col2)}>
                <div className={classes.paddingBox}>
                  {(() => {
                    if (this.props.mapping.get(item.key)) {
                      if (this.props.mapping.get(item.key).count() === 0) {
                        return (
                          <span className={classes.placeholder}>
                            追加されていません
                          </span>
                        );
                      } else {
                        if (step === SalesforceImportStep.MAPPING) {
                          return (
                            <div className={classes.chipContainer}>
                              {this.props.mapping
                                .get(item.key)
                                .toArray()
                                .map((field, i) => (
                                  <Chip
                                    key={i}
                                    label={
                                      this.props.fields[field]
                                        ? this.props.fields[field].label
                                        : ""
                                    }
                                    color="primary"
                                    classes={{
                                      root: classes.chipRoot,
                                      label: classes.chipLabel,
                                    }}
                                    onDelete={
                                      displayDeleteButton
                                        ? () => {
                                          this.handleChipsDelete(
                                            item.key,
                                            field
                                          );
                                        }
                                        : undefined
                                    }
                                    deleteIcon={
                                      <CancelCircle
                                        width={15}
                                        height={15}
                                        color="#6F9EFF"
                                      />
                                    }
                                  />
                                ))}
                            </div>
                          );
                        } else {
                          return (
                            <div>
                              {this.props.mapping
                                .get(item.key)
                                .toArray()
                                .map((field, i) => (
                                  <Chip
                                    key={i}
                                    label={
                                      this.props.fields[field]
                                        ? this.props.fields[field].label
                                        : "-"
                                    }
                                    color="primary"
                                    classes={{
                                      root: classes.chipRootGrey,
                                      label: classes.chipLabelGrey,
                                    }}
                                  />
                                ))}
                            </div>
                          );
                        }
                      }
                    }
                  })()}
                  <div className={classes.flex}></div>
                  {displayAddButton && (
                    <AddButton
                      fields={Object.values(this.props.fields)}
                      selectedFields={this.props.mapping.get(item.key)}
                      handleUpdateMapping={(value) =>
                        this.handleUpdateMapping(item.key, value)
                      }
                    />
                  )}
                </div>
              </div>
              <div className={classNames(classes.tableCell, classes.col3)}>
                {(step === SalesforceImportStep.PREVIEW ||
                  step === SalesforceSettingStep.OVERVIEW) && (
                    <div className={classes.previewBox}>
                      {!this.isFieldEmptySelection(item.key) &&
                        preview.map((previewItem, j) => (
                          <span className={classes.previewItem} key={j}>
                            {previewItem[item.key] ? previewItem[item.key] : "-"}
                          </span>
                        ))}
                    </div>
                  )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

MappingTable.propTypes = {
  classes: PropTypes.object.isRequired,
  step: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  mapping: PropTypes.object.isRequired,
  enableEdit: PropTypes.bool,
  isLoadingMapping: PropTypes.bool,
  isLoadingPreview: PropTypes.bool,
  fields: PropTypes.object,
  preview: PropTypes.array,
  updateMapping: PropTypes.func,
  sobject: PropTypes.string,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(MappingTable);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/MappingTable.jsx